import FieldTypesEnum from '../Enums/FieldTypesEnum';
import OpportunityStatusEnum from '../Enums/OpportunityStatusEnum';
import JsxHelper from '../Helpers/JsxHelper';
import React from 'react';
import moneyHelper from '../Helpers/moneyHelper';
import DataTableActionMenu from '../Elements/DataTable/DataTableActionMenu';

class ServiceFeeItem {
  constructor(item) {
    if (item === undefined) {
      this.ServiceFeeId = '';
      this.ServiceId = '';
      this.TypeId = '';
      this.Amount = '';
      this.Description = '';
      this.IsInvoiced = '';
      this.CreatedOn = '';
      this.CreatedBy = '';
      this.ModifiedOn = '';
      this.ModifiedBy = '';
      this.ClientLineId = '';
      this.ClientInvoiceYRMO = '';
      this.ClientInvoiceId = '';
      this.TypeName = '';
      this.OpportunityCurrency = '';
      this.OpportunityCurrencyCode = '';
      this.OpportunityStatusCode = '';
      this.PurchaseAmtCurId = '';
      this.HasTpClientInvoiceLineItem = false;
      return;
    }
    this.ServiceFeeId = item.serviceFeeId;
    this.ServiceId = item.serviceId;
    this.TypeId = item.typeId;
    this.Amount = item.amount;
    this.Description = item.description;
    this.IsInvoiced = item.isInvoiced;
    this.CreatedOn = item.createdOn;
    this.CreatedBy = item.createdBy;
    this.ModifiedOn = item.modifiedOn;
    this.ModifiedBy = item.modifiedBy;
    this.ClientLineId = item.clientLineId;
    this.ClientInvoiceYRMO = item.clientInvoiceYRMO;
    this.ClientInvoiceId = item.clientInvoiceId;
    this.TypeName = item.typeName;
    this.OpportunityCurrency = item.opportunityCurrency;
    this.OpportunityCurrencyCode = item.opportunityCurrencyCode;
    this.OpportunityStatusCode = item.opportunityStatusCode;
    this.PurchaseAmtCurId = item.currency;
    this.HasTpClientInvoiceLineItem = item.hasTpClientInvoiceLineItem;
  }

  static NameOfTheIdField() {
    return 'ServiceFeeId';
  }
  static nameOfTheItemDetailList() {
    return 'ServiceFeeId';
  }

  static MoneyFields = [];

  static Currency() {
    return '';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return '';
  }

  static DateFields = ['ModifiedOn'];

  static BoolFields = [];
  static FieldsToShowInListTable = [];

  static FieldsToShowInDataTable() {
    return [
      { label: 'Other Fee ID', orderById: 'ServiceFeeId', data: 'ServiceFeeId', minWidth: 30 },
      { label: 'Type', orderById: 'TypeId', data: 'TypeName', minWidth: 30 },
      {
        label: 'Amount',
        orderById: 'Amount',
        data: (item) => moneyHelper.toMoneyFormat(item.Amount, item.OpportunityCurrencyCode),
        minWidth: 30,
      },
      { label: 'Description', orderById: 'Description', data: 'Description', minWidth: 30 },
      { label: 'BARE Invoice #', orderById: 'Description', data: 'ClientInvoiceId', minWidth: 30 },
      { label: 'Invoice Revenue Period', orderById: 'Description', data: 'ClientInvoiceYRMO', minWidth: 30 },
      { label: 'Included?', orderById: 'IsIncluded', data: (item) => JsxHelper.YesNo(item.IsInvoiced), minWidth: 30 },
      {
        label: ' ',
        orderById: '',
        data: ServiceFeeItem.getActionsContent,
        type: FieldTypesEnum.ActionButton,
        tableminWidth: '50px',
      },
    ];
  }

  static getActionsContent(item) {
    return (
      <DataTableActionMenu
        options={[
          {
            iconName: 'fa-solid fa-edit',
            text: 'Edit',
            roleKey: 'opportunity_edit',
            disabled:
              item.OpportunityStatusCode === OpportunityStatusEnum.OpportunityWon ||
              item.OpportunityStatusCode === OpportunityStatusEnum.OpportunityLost,
            onClick: () => ServiceFeeItem.editGeneralFunction(item.ServiceFeeId, item),
          },
          {
            iconName: 'fa-regular fa-trash-can',
            text: 'Remove',
            roleKey: 'opportunity_edit',
            disabled:
              item.OpportunityStatusCode === OpportunityStatusEnum.OpportunityWon ||
              item.OpportunityStatusCode === OpportunityStatusEnum.OpportunityLost,
            onClick: () => ServiceFeeItem.clickOnRemove(item.ServiceFeeId, item),
          },
          {
            iconName: 'fa-solid fa-hands-bound',
            roleKey: 'opportunity_edit',
            text:
              item.ClientLineId === null
                ? 'Generate Invoice'
                : item.OpportunityStatusCode === OpportunityStatusEnum.OpportunityWon
                ? `invoice number ${item.ClientLineId}`
                : `Invoice status must be Won`,
            disabled: item.ClientLineId !== null || item.OpportunityStatusCode !== OpportunityStatusEnum.OpportunityWon,
            onClick: () => ServiceFeeItem.GenerateInvoice(item.ServiceFeeId, item),
          },
          {
            iconName: 'fa-solid fa-hands-bound',
            roleKey: 'tpclientinvoices_create',
            text:
              item.ClientLineId === null
                ? 'Generate Invoice New'
                : item.OpportunityStatusCode === OpportunityStatusEnum.OpportunityWon
                ? `invoice number ${item.ClientLineId}`
                : `Invoice status must be Won`,
            disabled:
              item.HasTpClientInvoiceLineItem === true ||
              item.OpportunityStatusCode !== OpportunityStatusEnum.OpportunityWon,
            onClick: () => ServiceFeeItem.GenerateInvoiceNew(item.ServiceFeeId, item),
          },
        ]}
      />
    );
  }
  static editGeneralFunction = (id, user, userList) => {
    alert('Empty function');
  };

  static clickOnRemove = (id, user, userList) => {
    alert('Empty function');
  };

  static GenerateInvoice = (id, user, userList) => {
    alert('Empty function');
  };

  static GenerateInvoiceNew = (id, user, userList) => {
    alert('Empty function');
  };
}

export default ServiceFeeItem;
